import React, { Component } from "react";
import DashboardHeader from "../../../Header/DashboardHeader";
import DashboardFooter from "../../../Footer/DashboardFooter";
import DashboardLeftMenu from "../../../Dashboard/DashboardLeftMenu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tabs, Tab } from "react-bootstrap-tabs";

import {
    faBroadcastTower,
    faArrowCircleLeft,
    faAddressBook,
    faCheckCircle,
    faFlag,
    faArrowCircleRight,
    faLink
} from "@fortawesome/free-solid-svg-icons";
import "react-datepicker/dist/react-datepicker.css";
import Alert from "../../../UI/Alert/Alert";
import Spining from "../../../UI/Spining/Spining";
import { CAMPAIGN_CONTACT_LIST_API } from "../../../../constants/ServiceConstants";
import api from "../../../../axios/Axios";
import { Link } from "react-router-dom";
import { no_data } from "../../../../images/WhatsAppImages";
import {
    campaignContactList,
    getSMSTemplateList,
    getCampaignSMSTemplateList,
    getUserPriceList,
    contactListAPI,
    createSMSCampaign,
    translateAPI,
    HOST_URL_DB2,
    HOST_URL
} from "../../api/Api";
import Axios from "axios";
import { Helmet } from "react-helmet";
import UploadCSVFile from "../component/UploadCSVFile";
import SMSPreview from "../../sms/component/SMSPreview";
import { withRouter } from 'react-router-dom';
import UploadExcelFile from "../component/UploadExcelFile";
import Select from "react-select";
import style from '../Rcs/rcscampaign.module.css'
import { Carousel } from "react-responsive-carousel";
import DownloadButton from "../Rcs/SampleCsv";
import UrlShortenerModal from "./UrlShortenerModal";
import DynamicTable from "../DynamicTable";
class SmsCampaignNew extends Component {
    constructor(props) {
        const lStorage = JSON.parse(localStorage.getItem("login"));
        const userId = lStorage?.user?.userId;
        const userToken = lStorage?.token;
        var today = new Date(),
            date =
                today.getFullYear() +
                "-" +
                (today.getMonth() + 1) +
                "-" +
                ("0" + today.getDate()).slice(-2);
        super(props);
        this.state = {
            user_id: userId,
            token: userToken,
            contactList: "",
            contactOption: [],
            step: 0, // TODO 0
            templatePreView: "",
            previewData: "",
            sampleData: "",
            WhatsappTemplateList: "",
            option: [],
            smsTemplateList: "",
            schedule_datetime: date,
            is_schedule: 0,
            parameter: [],
            mobile_colum: "",
            tableColume: [],
            countryList: [],
            varibaleInTemplate: "",
            CampaignName: "",
            channel: "sms",
            templteId: "",
            templateName: "",
            listId: "",
            is_flash: "",
            SMSmessage: [],
            country_code: 91,
            campaignType: "1",
            textnumbers: "",
            smsTemplateDetails: null,
            AllowLongMsg: false,
            selectedListName: "",
            totalCount: "",
            isLoading: false,
            uploadProgress: 0,
            errorMessage: "",
            isError: false,
            messageType: "",
            is_unicode: false,
            allow_Long_Msg: false,
            flash_message: false,
            language: "",
            numbersArray: [],
            urlPath: window.location,
            fileData: "",
            countData: "",
            selectedOption: null,
            dynamicSampleData: [],
            csvHeaders: [],
            filteredHeaders: [],
            csvRows: [],
            mainMsg: '',
            bodyVar: [],
            bodyValue: '',
            variableMapping: {},
            previews: [],
            urlModalVisible: false,
            selectedUrl: "",
            mainUrl: "",
            caretPosition: { start: 0, end: 0 },
        };
        this.errorRef = React.createRef();
        this.nextStep = this.nextStep.bind(this);
        this.findAndReplace = this.findAndReplace.bind(this);
        this.preViewSMSHandler = this.preViewSMSHandler.bind(this);
        this.getCsvData = this.getCsvData.bind(this);
        this.scheduleHandler = this.scheduleHandler.bind(this);
        this.handleChannel = this.handleChannel.bind(this);
    }

    componentDidMount() {
        this.getContactList();
        this.getDLTSMSTemplateList();
        this.fetchCountryCode();

    }



    hasUnicode = (str) => {
        // regex: match anything outside basic ASCII (0-127)
        return /[^\u0000-\u007F]/.test(str);
    };

    componentDidUpdate(prevProps, prevState) {
        // Check only when SMSmessage changes
        if (prevState.SMSmessage !== this.state.SMSmessage) {
            if (this.hasUnicode(this.state.SMSmessage)) {
                this.setState({ is_unicode: true });
            } else {
                this.setState({ is_unicode: false });
            }
        }

        if (this.state.isError && !prevState.isError) {
            if (this.errorRef.current) {
                const topPosition = this.errorRef.current.getBoundingClientRect().top + window.pageYOffset;
                window.scrollTo({
                    top: topPosition - 80, // You can adjust this value to move it further up
                    behavior: 'smooth'
                });
            }
        }
    }

    handleUnicodeToggle = () => {
        const { SMSmessage, is_unicode } = this.state;

        if (this.hasUnicode(SMSmessage)) {
            // 🚨 Prevent deselection if Unicode exists
            if (is_unicode) {
                // Already checked → block unchecking
                this.setState({
                    isError: true,
                    messageType: "alert-danger",
                    errorMessage: "Message contains Unicode characters, Unicode mode cannot be disabled.",
                })
                return;
            } else {
                // If unchecked but Unicode exists → force check
                this.setState({ is_unicode: true });
            }
        } else {
            // ✅ Normal toggle if no Unicode in message
            this.setState({ is_unicode: !is_unicode });
        }
    };

    fetchCountryCode = async () => {
        const payload = {
            user_id: this.state.user_id,
            token: this.state.token,
            method: "retrieve",
        }

        try {
            const { data } = await Axios.post(`${HOST_URL}/user_pricelist.php`, payload);
            if (data.success) {

                this.setState({ countryList: [...data.data] })

            }

        } catch (error) {
            this.setState({
                isError: true,
                messageType: "alert-danger",
                errorMessage: "error in fetching country list, please try again later",
            })

        }
    }

    getDLTSMSTemplateList = async () => {
        let paramData = {
            user_id: this.state.user_id,
            method: "retrieve",
            id: null,
            token: this.state.token
        }
        getSMSTemplateList(paramData).then((res) => {
            if (res.data.success === true) {
                let data = res.data.data;
                this.setState({
                    smsTemplateList: data,
                });
                data.forEach((item) => {
                    let newData = { value: item.id, label: item.template_name };
                    this.setState((prevState) => ({
                        option: [...prevState.option, newData],
                    }));
                })
            }
        });
    };

    openUrlModal = () => {
        const textarea = this.textAreaRef;
        if (textarea) {
            this.setState({
                caretPosition: {
                    start: textarea.selectionStart,
                    end: textarea.selectionEnd,
                },
                urlModalVisible: true,
            });
        }
    };


    // handleUrlSelect = (value) => {
    //     this.setState({ selectedUrl: value, urlModalVisible: false })
    //     this.setState((prevState) => ({
    //         SMSmessage: `${prevState.SMSmessage} ${value}`
    //     }))
    // }

    handleUrlSelect = (item) => {

        let value = item.url;
        const senderId = this.state.smsTemplateDetails[0].senderid;
        const allowSenderStr = item.allow_sender || "";
        const allowSenderArr = allowSenderStr.split(",").map(s => s.trim());

        if (allowSenderArr.includes(senderId)) {
            const urlParts = value.split("/");
            const firstParam = urlParts[3];
            if (firstParam !== senderId) {
                // replace first param with senderId
                urlParts[3] = senderId;
                value = urlParts.join("/");
                this.setState({
                    isError: false,
                    messageType: "",
                    errorMessage: "",
                })
            }
        } else {
            this.setState({
                urlModalVisible: false,
                isError: true,
                messageType: "alert-danger",
                errorMessage: "The selected URL is invalid. Please choose a valid URL or create a new one.",
            })
            return;
        }

        const { start, end } = this.state.caretPosition;
        const originalText = this.state.mainMsg;
        const currentText = this.state.SMSmessage;

        const updatedMainMsg =
            originalText.substring(0, start) + value + originalText.substring(end);


        const newText =
            currentText.substring(0, start) +
            value +
            currentText.substring(end);

        this.setState(
            {
                selectedUrl: value,
                mainUrl: item.main_url,
                urlModalVisible: false,
                SMSmessage: newText,
                mainMsg: updatedMainMsg,

            },
            () => {
                const newPreviewContent = this.formatMessage(
                    newText,
                    this.state.bodyVar,
                    this.state.bodyValue
                );

                this.setState({
                    templatePreView: {
                        ...this.state.templatePreView,
                        content: newPreviewContent,
                    },
                });
                // Restore focus and move caret after inserted URL
                setTimeout(() => {
                    if (this.textAreaRef) {
                        this.textAreaRef.focus();
                        const newPos = start + value.length;
                        this.textAreaRef.selectionStart = newPos;
                        this.textAreaRef.selectionEnd = newPos;
                    }
                }, 0);
            }
        );
    };




    isValid = () => {
        const { varibaleInTemplate, campaignType, variableMapping, mobile_colum, bodyValue, step, CampaignName } = this.state;
        if (
            CampaignName === undefined ||
            CampaignName === ""
        ) {
            this.setState({
                isError: true,
                messageType: "alert-danger",
                errorMessage: "Please Enter Campaign Name",
                isLoading: false,
            });
            return false;
        }
        // ✅ Validate for Campaign Type 1 (Fixed Values)
        if (campaignType === "1" && step === 2) {
            for (let item of varibaleInTemplate) {
                if (item !== "mobile" && (!bodyValue[item] || bodyValue[item].trim() === "")) {
                    this.setState({
                        isError: true,
                        messageType: "alert-danger",
                        errorMessage: `Please enter a value for variable ${item}`,
                        isLoading: false,
                    });
                    return false;
                }
            }
        }

        // ✅ Validate for Campaign Type 3 (Column Selection)
        if (campaignType === "3" && step === 2) {
            for (let item of varibaleInTemplate) {
                const key = `{#${item}#}`;

                // Check if mobile column is selected
                if (item === "mobile" && !mobile_colum) {
                    this.setState({
                        isError: true,
                        messageType: "alert-danger",
                        errorMessage: "Please select the mobile column",
                        isLoading: false,
                    });
                    return false;
                }

                // Check if all required columns are mapped
                if (item !== "mobile" && (!variableMapping[key] || variableMapping[key].trim() === "")) {
                    this.setState({
                        isError: true,
                        messageType: "alert-danger",
                        errorMessage: `Please select a column for variable ${item}`,
                        isLoading: false,
                    });
                    return false;
                }
            }
        }
        return true;
    };

    clearError = () => {
        this.setState({
            isError: false,
            messageType: "",
            errorMessage: "",

        })
    }

    nextStep = async () => {
        if (this.isValid()) {
            this.setState({
                step: this.state.step + 1,
            });
        }
    };

    prevStep = () => {
        this.setState({ step: this.state.step - 1 });
    };

    getContactList = () => {
        let params = {
            user_id: this.state.user_id,
            method: "retrieve",
            token: this.state.token
        }
        contactListAPI(params).then((res) => {
            if (res.data.success === true) {
                let ctList = res.data.data;
                ctList.forEach((item) => {
                    let newCtData = { value: item.id, label: `${item.name}(${item.number_count})` };
                    this.setState((prevState) => ({
                        contactOption: [...prevState.contactOption, newCtData],
                    }));
                });
                this.setState({
                    contactList: res.data.data,
                    isLoading: false,
                });
            } else {
                this.setState({ ErrorResponse: res.data, isLoading: false });
            }
        });
    };

    createCampaign = async () => {
        this.setState({ isLoading: true });
        const newArr = [{ id: this?.state?.selectedOption?.value }];

        let formattedVariableMapping;
        let parameterObject;
        if (this.state.campaignType === "3"
            // && this.state.listId
        ) {
            formattedVariableMapping = Object.fromEntries(
                Object.entries(this.state.variableMapping).map(([key, value]) => [
                    key.replace(/[{}#]/g, ""), // Remove double curly braces
                    `#${value}#`
                ])
            );

        }
        // else {
        //     formattedVariableMapping = Object.fromEntries(
        //         Object.entries(this.state.variableMapping).map(([key, value]) => [
        //             key.replace(/[{}#]/g, ""), // Remove double curly braces
        //             `#${value}#` // Convert to lowercase and add #
        //         ])
        //     );
        // }
        parameterObject = { ...formattedVariableMapping }
        let createSMSCampaignData = {
            token: this.state.token,
            user_id: this.state.user_id,
            channel: this.state.channel,
            template_id: this.state.templteId,
            list_id: this.state.listId,
            parameter: this.state.campaignType === "1" ? JSON.stringify(this.state.parameter) : JSON.stringify(parameterObject),
            mobile_colum: this.state.mobile_colum,
            camp_name: this.state.CampaignName,
            total_count: this.state.totalCount,
            country_code: this.state.country_code,
            camp_type: this.state.campaignType,
            message: this.state.campaignType === "1" ? this.state.SMSmessage : this.state.mainMsg,
            textnumbers: this.state.textnumbers,
            entity_id: this.state.smsTemplateDetails[0].entity_id,
            template_id: this.state.smsTemplateDetails[0].template_id,
            sender_id: this.state.smsTemplateDetails[0].senderid,
            schedule_datetime: this.state.schedule_datetime,
            is_schedule: this.state.is_schedule,
            language: this.state.language,
            is_unicode: this.state.is_unicode === true ? 1 : 0,
            allow_Long_Msg: this.state.allow_Long_Msg === true ? 1 : 0,
            flash_message: this.state.flash_message === true ? 1 : 0,
            method: "create",
            dynamic_content: this.state.bodyVar.length > 0 ? 1 : 0,
            short_url: this.state.selectedUrl,
            main_url: this.state.mainUrl

        };

        const formData = new FormData();

        Object.entries(createSMSCampaignData).forEach(([key, value]) => {
            formData.append(key, value);
        });


        // if (this.state.fileData) {
        //     formData.append('fileData', this.state.fileData);
        // }

        if (this.state.fileData && this.state.campaignType === "1") {
            formData.append("fileData", this.state.fileData);
        }
        if (this.state.fileData && this.state.campaignType === "3") {
            const filteredKeys = [...this.state.filteredHeaders, this.state.mobile_colum];
            const filteredData = this.state.countData.map((entry) => {
                const filteredEntry = {};
                filteredKeys.forEach((key) => {
                    if (entry.hasOwnProperty(key)) {
                        filteredEntry[key] = entry[key];
                    }
                });
                return filteredEntry;
            });

            const countDataJson = JSON.stringify(filteredData);


            formData.append("customise_data", countDataJson);
        }

        try {
            const response = await fetch(`${HOST_URL_DB2}/bulk_campaign_sms.php`, {
                method: 'POST',
                body: formData,
            });

            const result = await response.json();

            if (result.success) {
                this.setState({
                    isError: true,
                    messageType: "alert-success",
                    errorMessage: result.message,
                    isLoading: false,
                });
                setTimeout(() => {
                    window.location = "/dashboard/campaign";
                }, 1000);
            } else {
                this.setState({
                    isError: true,
                    messageType: "alert-danger",
                    errorMessage: result.message,
                    isLoading: false,
                });
            }
        } catch (error) {
            console.error('Error uploading campaign:', error);
            const statusCode = error.response?.status;
            let messageType = "alert-danger";
            let errorMsg = `${statusCode ? `[${statusCode}] ` : ''}${error.response?.data?.message || "An error occurred while creating the campaign."}`;
            this.setState({
                isError: true,
                messageType,
                errorMessage: errorMsg,
                isLoading: false,
            });
        }
    };

    selectedSMSTemplate = async (e) => {
        this.setState({ templteId: e.value, templateName: e.label });
        this.setState({
            bodyValue: '',
            parameter: [],
            bodyVar: [],
            mainMsg: '',
            variableMapping: {},
            previews: [],

        })
        let params = {
            user_id: this.state.user_id,
            method: "retrieveid",
            id: e.value,
            token: this.state.token
        }
        getCampaignSMSTemplateList(params).then((res) => {
            if (res.data.success === true) {
                this.extractData(res.data.data[0].content)
                const bodyVariables = res.data.data[0].content.match(/\{#([^#]+)#\}/g) || [];

                this.getVariable(res.data.data[0].content);
                this.setState({
                    isError: false,
                    smsTemplateDetails: res.data.data,
                    SMSmessage: res.data.data[0].content,
                    mainMsg: res.data.data[0].content,
                    templatePreView: res.data.data[0],
                    bodyVar: [...bodyVariables]
                });
                this.isUnicode(); // to check language

            } else {
                this.setState({
                    isError: true,
                    messageType: "alert-danger",
                    errorMessage: res.data.message,
                    isLoading: false,
                });
            }
        });
    };

    getVariable = (data) => {
        var regex = /{#([^#]+)#}/g;
        let m;
        var tempArr = ["mobile"];
        var parameter = {};
        while ((m = regex.exec(data)) !== null) {
            if (m.index === regex.lastIndex) {
                regex.lastIndex++;
            }
            parameter[`${m[1]}`] = "";
            tempArr.push(m[1]);
        }
        this.setState({
            varibaleInTemplate: tempArr,
            parameter: [...this.state.parameter, parameter],
        });
    };

    setParameter = (e) => {
        this.state.parameter.map((item, i) => {
            Object.keys(item).map((key) => {
                if (key === e.target.name) {
                    let obj = (this.state.parameter[i][key] = e.target.value);
                    this.findAndReplace(e.target.name, obj);
                } else {
                    console.log("something went wrong");
                }
            });
        });
    };

    getColumedata = (id) => {
        let params = {
            user_id: this.state.user_id,
            method: "retrieve_data",
            token: this.state.token,
            list_id: id
        }
        campaignContactList(params).then((res) => {
            this.setState({ isLoading: true });
            try {
                if (res.data.success === true) {
                    this.setState({
                        tableColume: Object.keys(res.data.data[0]),
                        previewData: res.data.data,
                        isLoading: false,
                    });
                } else {
                    this.setState({ isLoading: false });
                }
            } catch (error) {
                console.log("error", error);
            }
        });
    };

    contactListhandler = (e) => {
        if (!e) {
            // When cleared, reset state
            this.setState({
                selectedOption: null,
                textnumbers: "",
                numbersArray: [],
                fileData: "",
                sampleData: "",
                countData: "",
                tableColume: [],
                dynamicSampleData: [],
                selectedListName: "",
                totalCount: 0,
                listId: "",
            });
            this.clearTemplatePreview();
            return;
        }

        // When a valid option is selected
        this.setState({
            selectedOption: e,
            // textnumbers: "", numbersArray: [] 
        });

        if (this.state.fileData && this.state.campaignType === "3") {
            this.setState({
                fileData: "",
                sampleData: "",
                countData: "",
                tableColume: [],
                dynamicSampleData: [],
                mobile_colum: "",
            });
        }

        this.clearTemplatePreview();
        this.setState({ listId: e.value });

        var item = this.state.contactList.filter(
            (item) => item.id === parseInt(e.value)
        );

        this.setState({
            selectedListName: item[0]?.name || "", // Use optional chaining to prevent errors
            totalCount: item[0]?.number_count || 0, // Default to 0 if not found
        });

        this.getColumedata(e.value);
        this.getSampleData(e.value);
    };

    getSampleData = async (id) => {
        try {
            const { data } = await api.post(CAMPAIGN_CONTACT_LIST_API, {
                token: this.state.token,
                user_id: this.state.user_id,
                list_id: id,
                method: "retrieve_data_sample",
            });
            if (data.success === true) {
                this.setState({ sampleData: data.data, setIsLoading: false });
                const csvHeaders = data.data[0]
                    ? Object.keys(data.data[0]).map((header) => header.trim())
                    : [];
                const csvRows = data.data.map((item) => Object.values(item));
                this.setState({ csvHeaders: csvHeaders, csvRows: csvRows })
            } else {
                this.setState({ ErrorResponse: data, setIsLoading: false });
            }
        } catch (err) {
            console.log(err);
        }
    };

    renderSampleData = () => {
        let data = this.state.sampleData;
        if (data.length > 0) {
            const column = Object.keys(data[0]);
            return (
                <>
                    <p>Your Table Data </p>
                    <table className="table table-hover  my-0">
                        <thead>
                            {column.map((data) => (
                                <th>{data}</th>
                            ))}
                        </thead>
                        {data.map((data) => (
                            <tr>
                                {column.map((v) => {
                                    return <td>{data[v]}</td>;
                                })}
                            </tr>
                        ))}
                    </table>
                </>
            );
        }
    };

    findAndReplace = (name, column) => {
        let text = this.state.templatePreView.bodyMessage;
        let replaceKeyword = `{{${name}}}`;
        let value = this.state.sampleData[0][column];
        let newtext = text.replace(replaceKeyword, value);
        let obj = (this.state.templatePreView["temp_body"] = newtext);
        this.setState({
            templatePreView: {
                ...this.state.templatePreView,
                ["bodyMessage"]: newtext,
            },
        });
    };

    getCsvData(data, countData) {
        const trimmedCountData = countData.map(item => {
            const trimmedObj = {};
            Object.keys(item).forEach(key => {
                trimmedObj[key.trim()] = item[key];  // Trim key here
            });
            return trimmedObj;
        });
        if (this.state.selectedOption && this.state.campaignType === "3") {
            this.setState({
                selectedOption: null, listId: "",
                selectedListName: "",
                totalCount: "",
                mobile_colum: ""
            })
        }
        // if (this.state.textnumbers) {
        //     this.setState({ textnumbers: "", numbersArray: [] })
        // }
        this.clearTemplatePreview();
        this.setState({
            // sampleData: data.rowData,
            fileData: data,
            countData: [...trimmedCountData],
            tableColume: data.tableColume,
            dynamicSampleData: trimmedCountData.splice(0, 5),
        });
        this.setCsvData();
    }

    setCsvData = () => {
        const { dynamicSampleData } = this.state;
        // Extract headers and data
        const csvHeaders = dynamicSampleData[0]
            ? Object.keys(dynamicSampleData[0]).map((header) => header.trim())
            : [];

        this.setState({ csvHeaders: csvHeaders })
        const csvRows = dynamicSampleData.map((item) => Object.values(item));
        this.setState({ csvRows: csvRows })
    }

    setLoading = (value) => {
        this.setState({ isLoading: value })
    }

    setUploadProgress = (value) => {
        this.setState({ uploadProgress: value })
    }

    clearTemplatePreview = () => {
        if (this.state.templteId) {
            this.setState({
                templteId: "",
                templateName: "",
                templatePreView: "",
                mainMsg: '',
                bodyVar: [],
                varibaleInTemplate: "",
                parameter: [],
                variableMapping: {},
                previews: [],
                smsTemplateDetails: null,

            })

        }
    }

    handleCampaignType = (e) => {
        this.setState({
            campaignType: e.target.value,
            textnumbers: "",
            numbersArray: []
        })
        if (this.state.selectedOption) {
            this.setState({
                selectedOption: null, listId: "",
                selectedListName: ""
            })
        }
        if (this.state.fileData) {
            this.setState({
                fileData: "",
                sampleData: "",
                countData: "",
                tableColume: [],
                dynamicSampleData: [],
                csvHeaders: [],
                filteredHeaders: [],
                csvRows: [],
            })
        }

        this.clearTemplatePreview();

    }

    charaterCount = (text) => {
        var newstr = text.replace(/ /g, " ");
        var patt = new RegExp("[^\x00-\x7F]");
        var res = patt.test(newstr);
        var charLength = text.replace(/{|}|\[|\]|~|\^|\||\\/g, "  ");
        var outputString = parseInt(charLength.length);
        let obj = {
            total: "",
            credit: "",
        };
        if (res) {
            if (outputString < 70) {
                obj["total"] = outputString;
                obj["credit"] = 1;
            } else if (outputString / 70 == 1) {
                obj["total"] = outputString;
                obj["credit"] = Math.round(outputString / 70);
            } else {
                obj["total"] = outputString;
                obj["credit"] = Math.ceil(outputString / 67);
            }
        } else {
            if (outputString < 160) {
                obj["total"] = outputString;
                obj["credit"] = 1;
            } else if (outputString / 160 == 1) {
                obj["total"] = outputString;
                obj["credit"] = Math.round(outputString / 160);
            } else {
                obj["total"] = outputString;
                obj["credit"] = Math.ceil(outputString / 153);
            }
        }

        return (
            <p className="sms-count mb-0">
                <small>
                    Character Used <strong id="totalWords">{obj.total}</strong>
                </small>
                <small>
                    Credits
                    <strong> {obj.credit}</strong>
                </small>
            </p>
        );
    };

    preViewSMSHandler = async (e) => {
        const inputValue = e.target.value;
        const { mainMsg } = this.state;

        let APIResponce = "";
        let lastWord = e.target.value.split(" ");
        if (this.state.is_unicode) {
            if (e.key === " " && inputValue.trim() !== "") {
                let paramData = {
                    word: lastWord[lastWord.length - 1],
                    itc: this.state.language
                }
                await translateAPI(paramData).then((result) => {
                    APIResponce = result.data + " ";
                });
            }
        }
        if (APIResponce === "") {
            this.setState({
                SMSmessage: e.target.value,
            });
        } else {
            if (inputValue !== null) {
                var lastIndex = inputValue.lastIndexOf(lastWord[lastWord.length - 1]);
                let originalMessage = inputValue.substring(0, lastIndex);
                let mainMessage = mainMsg.substring(0, lastIndex);
                this.setState({
                    SMSmessage: `${originalMessage}${APIResponce}`,
                    mainMsg: `${mainMessage}${APIResponce}`,
                });
            }
        }

        this.charaterCount(inputValue);
    };

    scheduleHandler(e) {
        if (e.target.checked === true) {
            this.setState({ is_schedule: 1 });
        } else {
            this.setState({ is_schedule: 0 });
        }
    }

    isUnicode() {
        var message = this.state.SMSmessage;
        var newstr = message.replace(/ /g, " ");
        var patt = new RegExp("[^\x00-\x7F]");
        var res = patt.test(newstr);
        if (res) {
            this.setState({
                is_unicode: true,
            });
        } else {
            this.setState({
                is_unicode: false,
            });
        }
        return res;
    }

    onNameChange = (e) => {
        this.setState({ CampaignName: e.target.value });
        this.setState({ isError: false });
    };

    onChange = (e) => {
        // if (this.state.selectedOption) {
        //     this.setState({
        //         selectedOption: null, listId: "",
        //         selectedListName: ""
        //     })
        // }
        // if (this.state.fileData) {
        //     this.setState({
        //         fileData: "",
        //         sampleData: "",
        //         countData: "",
        //         tableColume: [],
        //         dynamicSampleData: [],
        //     })
        // }
        this.clearTemplatePreview();
        const value = e.target.value;
        // Allow only numbers and commas
        const validValue = value.replace(/[^0-9\n]/g, '');
        if (value !== validValue) {
            this.setState({
                isError: true,
                messageType: "alert-danger",
                errorMessage: "Please enter a valid input containing only numbers and commas.",
                isLoading: false,
            });
        } else {
            this.setState({ isError: false, errorMessage: "", messageType: "" });
        }
        this.setState({ textnumbers: validValue });
        this.newArray(validValue);
    };

    newArray = (data) => {
        const numbers = data.split(/\n+/)
            .map((num) => num.trim())
            .filter((num) => num !== "");
        this.setState({ numbersArray: numbers });
    };
    handleChannel(e) {
        const { pathname } = this.state.urlPath;
        const segments = pathname.split("/");
        const endPath = segments[segments.length - 1];
        const selectedChannel = e.target.value;

        if (selectedChannel === "whatsapp") {
            if (endPath === "campaign-start") {
                this.setState({ channel: selectedChannel });
            } else {
                this.props.history.push("/dashboard/campaign-start");
            }
        }

        if (selectedChannel === "sms") {
            if (endPath === "sms-campaign") {
                this.setState({ channel: selectedChannel });
            } else {
                this.props.history.push("/dashboard/sms-campaign");
            }
        }

        if (selectedChannel === "rcs") {
            if (endPath === "rcs-campaign") {
                this.setState({ channel: selectedChannel });
            } else {
                this.props.history.push("/dashboard/rcs-campaign");
            }
        }
    }

    extractData = (data) => {
        const pattern = /\{#([^#]+)#\}/g;
        const matches = [];
        let match;
        while ((match = pattern.exec(data)) !== null) {
            matches.push(match[1]);
        }

        return matches;
    };

    replaceBodyVal = (index, e) => {
        this.setState({
            isError: false,
            messageType: "",
            errorMessage: "",
        })
        const updatedValues = { ...this.state.bodyValue };
        updatedValues[e.target.name] = e.target.value;

        this.setState({ bodyValue: updatedValues, parameter: updatedValues });


        const bodydata = this.formatMessage(
            this.state.mainMsg,
            this.state.bodyVar,
            updatedValues
        );

        // Generate plain string for textarea content
        const plainText = this.generateTextMessage(
            this.state.mainMsg,
            this.state.bodyVar,
            updatedValues
        );


        this.setState({
            templatePreView: {
                ...this.state.templatePreView,
                ["content"]: bodydata,
            },
            SMSmessage: plainText
        });


    };

    formatMessage = (msg, placeholders, inputValues) => {


        const parts = msg.split(/\{#([^#]+)#\}/g);
        return parts.map((part, index) => {
            const placeholderKey = part;
            if (placeholders.includes(`{#${placeholderKey}#}`)
            ) {
                return (
                    <span key={index} style={{
                        color: inputValues[placeholderKey] ? "blue" : "", // Blue for input values, black for placeholders
                    }}>
                        {inputValues[placeholderKey] || `{#${part}#}`}
                    </span>
                );
            }

            return part;
        });
    };

    generateTextMessage = (msg, placeholders, inputValues) => {
        let output = msg;
        placeholders.forEach(ph => {
            const key = ph.replace(/\{#|\#\}/g, ""); // extract `otp` from `{#otp#}`
            const value = inputValues[key] || ph;
            output = output.replace(new RegExp(ph, 'g'), value);
        });
        return output;
    };


    handleMobileColumnSelect = (e) => {
        this.setState({
            isError: false,
            messageType: "",
            errorMessage: "",
            mobile_colum: e.target.value
        })

    }

    handleMapping = (variable, selectedHeader) => {
        this.setState({
            isError: false,
            messageType: "",
            errorMessage: "",
        })
        this.setState(
            (prevState) => {
                // Update the variable mapping with the new key-value pair
                const updatedVariableMapping = {
                    ...prevState.variableMapping,
                    [variable]: selectedHeader,
                };

                // Remove the previous value for this variable from filteredHeaders
                const updatedFilteredHeaders = prevState.filteredHeaders.filter(
                    (header) => header !== prevState.variableMapping[variable]
                );

                // Check if selectedHeader is already in filteredHeaders
                if (!updatedFilteredHeaders.includes(selectedHeader)) {
                    // Add the new selectedHeader only if it's not already in the array
                    updatedFilteredHeaders.push(selectedHeader);
                }

                return {
                    variableMapping: updatedVariableMapping,
                    filteredHeaders: updatedFilteredHeaders,

                };
            },
            () => {

                // Generate previews after mapping is updated


                const previews = this.generatePreviews();
                this.setState({
                    previews: previews.map((item) => ({
                        ...this.state.templatePreView, // Spread existing object
                        content: item, // Update the property
                    })),
                    SMSmessage: previews[0]
                });


            }
        );
    }


    generatePreviews() {
        const { csvRows, variableMapping, mainMsg } = this.state;
        // Generate previews for each row
        const previews = csvRows.map((row) => {
            let preview = mainMsg;
            Object.keys(variableMapping).forEach((variable) => {
                const header = variableMapping[variable];
                const columnIndex = this.state.csvHeaders.indexOf(header);
                if (columnIndex !== -1) {
                    preview = preview.replace(variable, row[columnIndex]);
                }
            });
            return preview;
        });


        return previews; // Previews can be shown in the carousel
    }


    formRender = () => {
        switch (this.state.step) {
            case 1:
                return (
                    <>
                        <div className="filter-option">
                            <div className="row">
                                <div className="col-md-12">
                                    <p className="d-block">
                                        Choose Audience to send the campaign on
                                        <span className="text-primary"> {this.state.channel} </span>
                                    </p>
                                    <div className="">
                                        <div>
                                            {this.state.campaignType === "1" &&
                                                <Tabs id="fall-back-tab">
                                                    <Tab label="Select From Contact List">
                                                        {this.state.contactList ? (
                                                            <div className="input-group drop-down-icons mb-2 mt-4 mr-sm-2">
                                                                <Select
                                                                    value={this.state.selectedOption}
                                                                    onChange={this.contactListhandler}
                                                                    options={this.state.contactOption}
                                                                    isSearchable={true}
                                                                    placeholder="Select Contact List"
                                                                    isClearable={true}
                                                                />

                                                            </div>
                                                        ) : (
                                                            <p className="alert alert-danger d-block">
                                                                You don't have any contacts please create{" "}
                                                                <Link to="/dashboard/contact-list">Contacts</Link>{" "}
                                                                and then come back.
                                                            </p>
                                                        )}
                                                    </Tab>
                                                    <Tab label="Copy Paste Data">
                                                        <div className="input-group flex flex-column mb-2 mt-4 mr-sm-2">
                                                            <p style={{ fontSize: '.8rem', color: 'red', wordBreak: "break-all" }}>
                                                                *Enter mobile number{' '}
                                                                {this.state.country_code === 99999
                                                                    ? '(with country code)'
                                                                    : '(without country code)'}{' '}
                                                                in new line
                                                            </p>
                                                            <textarea
                                                                placeholder="Enter Mobile Number"
                                                                onChange={this.onChange}
                                                                defaultValue={this.state.textnumbers}
                                                                className="form-control w-100"
                                                                rows={5}
                                                            ></textarea>
                                                        </div>
                                                        <span style={{ float: "right" }}>
                                                            count: {this.state.numbersArray.length + this.state.countData.length}
                                                        </span>
                                                    </Tab>
                                                    <Tab label="Upload .csv File">
                                                        <UploadCSVFile sendCsvData={this.getCsvData} setLoading={this.setLoading} />
                                                        <DownloadButton campaignType={this.state.campaignType} countryCode={this.state.country_code} />
                                                    </Tab>
                                                </Tabs>}
                                            {this.state.campaignType === "3" &&
                                                <Tabs id="fall-back-tab">
                                                    <Tab label="Select From Contact List">
                                                        {this.state.contactList ? (
                                                            <div className="input-group drop-down-icons mb-2 mt-4 mr-sm-2">

                                                                <Select
                                                                    value={this.state.selectedOption}  // Bind selected option to state
                                                                    onChange={this.contactListhandler}  // Handle onChange event
                                                                    options={this.state.contactOption}  // Options array
                                                                    isSearchable={true}  // Allow searching in options
                                                                    placeholder="Select Contact List"
                                                                    isClearable={true}  // Optional: allows clearing the selection
                                                                />

                                                            </div>
                                                        ) : (
                                                            <p className="alert alert-danger d-block">
                                                                You don't have any contacts please create{" "}
                                                                <Link to="/dashboard/contact-list">Contacts</Link>{" "}
                                                                and then come back.
                                                            </p>
                                                        )}
                                                    </Tab>
                                                    <Tab label="Upload .xls/.xlsx File">
                                                        <UploadExcelFile setUploadProgress={this.setUploadProgress} sendCsvData={this.getCsvData} setLoading={this.setLoading} />
                                                        <DownloadButton campaignType={this.state.campaignType} countryCode={this.state.country_code} />
                                                    </Tab>

                                                </Tabs>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                );
            case 2:
                return (
                    <>
                        <div className="filter-option">
                            <div className="row">
                                <div className="col-md-7">
                                    <p className="d-block mt-4">
                                        Select{" "}
                                        <span className="text-primary">{this.state.channel}</span>{" "}
                                        template to campaign
                                    </p>

                                    {this.state.smsTemplateList ? (
                                        <>
                                            <div className="d-flex align-items-center mb-2 mr-sm-2" style={{ flexWrap: "nowrap", width: "100%" }}>
                                                <div className="input-group-text d-flex align-items-center justify-content-center"
                                                    style={{ minWidth: "40px", height: "43px", marginBottom: "10px", borderRadius: "0.375rem 0 0 0.375rem" }}>
                                                    <FontAwesomeIcon
                                                        icon={faAddressBook}
                                                        className="mr-1"
                                                    />{" "}
                                                    Template
                                                </div>

                                                {/* <select
                                                    onChange={this.selectedSMSTemplate}
                                                    className="form-control"
                                                >
                                                    <option value={``}>Select Template</option>
                                                    {this.state.smsTemplateList.map((item, index) => (
                                                        <option key={index} value={item.id}>
                                                            {item.template_name}
                                                        </option>
                                                    ))}
                                                </select> */}
                                                <div style={{ flex: 1 }}>
                                                    <Select
                                                        value={this.state.templteId ?
                                                            {
                                                                value: this.state.templteId,
                                                                label: this.state.templateName
                                                            } : null}

                                                        onChange={this.selectedSMSTemplate}
                                                        options={this.state.option}
                                                        isSearchable={true}
                                                        placeholder="Select Template"
                                                        classNamePrefix="react-select"
                                                        styles={{
                                                            control: (provided) => ({
                                                                ...provided,
                                                                borderRadius: "0 0.375rem 0.375rem 0",
                                                                minHeight: "43px"
                                                            }),
                                                        }}
                                                    // isClearable
                                                    />

                                                </div>
                                            </div>

                                            {this.state.smsTemplateDetails && (
                                                <>
                                                    <div className="input-group mb-2 mr-sm-2">
                                                        <div className="input-group-text w-25">
                                                            <FontAwesomeIcon
                                                                icon={faAddressBook}
                                                                className="mr-1"
                                                            />{" "}
                                                            Entity ID
                                                        </div>
                                                        <input
                                                            type="text"
                                                            placeholder="Entity ID"
                                                            disabled
                                                            value={this.state.smsTemplateDetails[0].entity_id}
                                                            className="form-control"
                                                        />
                                                    </div>

                                                    <div className="input-group mb-2 mr-sm-2">
                                                        <div className="input-group-text w-25">
                                                            <FontAwesomeIcon
                                                                icon={faAddressBook}
                                                                className="mr-1"
                                                            />{" "}
                                                            Sender ID
                                                        </div>
                                                        <input
                                                            type="text"
                                                            placeholder="Sender ID"
                                                            className="form-control"
                                                            disabled
                                                            value={this.state.smsTemplateDetails[0].senderid}
                                                        />
                                                    </div>

                                                    <div className="input-group mb-2 mr-sm-2">
                                                        <div className="input-group-text w-25">
                                                            <FontAwesomeIcon
                                                                icon={faAddressBook}
                                                                className="mr-1"
                                                            />{" "}
                                                            Template ID
                                                        </div>
                                                        <input
                                                            type="text"
                                                            disabled
                                                            placeholder="Template ID"
                                                            className="form-control"
                                                            value={
                                                                this.state.smsTemplateDetails[0].template_id
                                                            }
                                                        />
                                                    </div>

                                                    {this.state.varibaleInTemplate && (
                                                        <>
                                                            {this.state.campaignType === "3" && <p>Please select column </p>}
                                                            {this.state.varibaleInTemplate.map((item, index) => (
                                                                <div key={index} className="input-group mb-2 mr-sm-2">
                                                                    {this.state.campaignType === "1" && item !== "mobile" && <div className="input-group-text">{item}</div>}
                                                                    {this.state.campaignType === "3" && <div className="input-group-text">{item}</div>}

                                                                    {/* Show dropdown if campaignType is "3" */}
                                                                    {this.state.campaignType === "3" && (
                                                                        <select name={item}
                                                                            onChange={item !== "mobile"
                                                                                ? (e) => this.handleMapping(`{#${item}#}`, e.target.value)
                                                                                : this.handleMobileColumnSelect}
                                                                            value={item !== "mobile"
                                                                                ? (this.state.variableMapping[`{#${item}#}`] || "")
                                                                                : this.state.mobile_colum}
                                                                            className="form-control">
                                                                            <option value="">Select Column</option>
                                                                            {this.state.csvHeaders?.map((column, colIndex) => (
                                                                                <option key={colIndex} value={column}>{column}</option>
                                                                            ))}
                                                                        </select>
                                                                    )}

                                                                    {/* Skip input for "mobile", otherwise show input if campaignType is "1" */}
                                                                    {item !== "mobile" && this.state.campaignType === "1" && (
                                                                        <input type="text" name={item} className="form-control"
                                                                            placeholder={`Enter variable value`}
                                                                            value={this.state.parameter[item]}
                                                                            onChange={(e) => this.replaceBodyVal(index, e)} />
                                                                    )}
                                                                </div>
                                                            ))}
                                                        </>
                                                    )}

                                                    <textarea
                                                        ref={(ref) => (this.textAreaRef = ref)}
                                                        onChange={this.preViewSMSHandler}
                                                        rows={5}
                                                        disabled={
                                                            this.state.is_unicode &&
                                                                this.state.language === ""
                                                                ? true
                                                                : false
                                                        }
                                                        value={this.state.SMSmessage}
                                                        className="form-control mt-3"
                                                        onKeyDown={this.preViewSMSHandler} // Use onKeyDown instead of onKeyPress
                                                    ></textarea>

                                                    {this.charaterCount(this.state.SMSmessage)}

                                                    <div className="d-flex mb-3 justify-content-start align-items-center">
                                                        <small className="ml-4 mt-2 d-flex align-items-center">
                                                            <input
                                                                type="checkbox"
                                                                value={this.state.is_unicode}
                                                                checked={this.state.is_unicode || false}
                                                                className="form-check-input mb-1 mr-2"
                                                                id="fallback"
                                                                onChange={this.handleUnicodeToggle}
                                                            />
                                                            <span> Enable Unicode </span>
                                                        </small>
                                                        <small className="ml-4 mt-2 d-flex align-items-center">
                                                            <input
                                                                value="1"
                                                                type="checkbox"
                                                                checked={
                                                                    this.state.SMSmessage.length > 160
                                                                        ? true
                                                                        : false
                                                                }
                                                                className="form-check-input mb-1 mr-2"
                                                                id="fallback"
                                                            />
                                                            <span> Allow Long Msg </span>
                                                        </small>
                                                        <small className="ml-4 mt-2 d-flex align-items-center">
                                                            <input
                                                                value="1"
                                                                type="checkbox"
                                                                className="form-check-input mb-1 mr-2"
                                                                id="fallback"
                                                                onChange={(e) => this.setState({ is_flash: 1 })}
                                                            />
                                                            <span> Flash Message </span>
                                                        </small>
                                                        <small className="ml-2 mt-2 d-flex align-items-center" role="button"
                                                            onClick={this.openUrlModal}
                                                        >
                                                            <FontAwesomeIcon icon={faLink} />
                                                            <span className="ml-1"> Url Shortener </span>
                                                        </small>
                                                    </div>
                                                    {this.state.is_unicode && (
                                                        <>
                                                            <div className="input-group drop-down-icons mb-2 mr-sm-2">
                                                                <div className="input-group-text w-25">
                                                                    <FontAwesomeIcon
                                                                        icon={faAddressBook}
                                                                        className="mr-1"
                                                                    />{" "}
                                                                    Language
                                                                </div>

                                                                <select
                                                                    onClick={(e) =>
                                                                        this.setState({ language: e.target.value })
                                                                    }
                                                                    className="form-control"
                                                                >
                                                                    <option value={``}>Select Language</option>
                                                                    <option value="hi-t-i0-und">Hindi</option>
                                                                    <option value="am-t-i0-und">Amharic</option>
                                                                    <option value="ar-t-i0-und">Arabic</option>
                                                                    <option value="bn-t-i0-und">Bengali</option>
                                                                    <option value="el-t-i0-und">Greek</option>
                                                                    <option value="gu-t-i0-und">Gujarati</option>
                                                                    <option value="kn-t-i0-und">Kannada</option>
                                                                    <option value="ml-t-i0-und">Malayalam</option>
                                                                    <option value="mr-t-i0-und">Marathi</option>
                                                                    <option value="ne-t-i0-und">Nepali</option>
                                                                    <option value="or-t-i0-und">Oriya</option>
                                                                    <option value="fa-t-i0-und">Persian</option>
                                                                    <option value="pu-t-i0-und">Punjabi</option>
                                                                    <option value="ru-t-i0-und">Russian</option>
                                                                    <option value="sa-t-i0-und">Sanskrit</option>
                                                                    <option value="sr-t-i0-und">Serbian</option>
                                                                    <option value="si-t-i0-und">Sinhalese</option>
                                                                    <option value="ta-t-i0-und">Tamil</option>
                                                                    <option value="te-t-i0-und">Telugu</option>
                                                                    <option value="th-t-i0-und">Thai</option>
                                                                    <option value="ti-t-i0-und">Tigrinya</option>
                                                                    <option value="ur-t-i0-und">Urdu</option>
                                                                    <option value="yue-hant-t-i0-und">
                                                                        Chinese
                                                                    </option>
                                                                </select>
                                                            </div>
                                                            <small className="text-danger">
                                                                {this.state.is_unicode &&
                                                                    this.state.language === ""
                                                                    ? "Please select Language"
                                                                    : null}
                                                            </small>
                                                        </>
                                                    )}
                                                </>
                                            )}
                                        </>
                                    ) : (
                                        <p className="alert alert-danger d-block">
                                            You don't have any template please create{" "}
                                            <Link to="/dashboard/whatsapp-template-list">
                                                Template
                                            </Link>{" "}
                                            and then come back.
                                        </p>
                                    )}



                                    <hr />
                                    {this.state.channel === "whatsapp" && (
                                        <div className="card p-2">
                                            <div className="table-responsive">
                                                {this.renderSampleData()}
                                            </div>
                                        </div>
                                    )}
                                    {this.state.countData.length > 0 && <DynamicTable data={this.state.dynamicSampleData} />}
                                </div>
                                <div className="col-md-5">
                                    <div className="card">
                                        <div className="card-header">
                                            <h5 className="card-title mb-0"> Template Preview </h5>
                                        </div>
                                        <hr className="m-0" />
                                        <div className="card-body">
                                            {this.state.templatePreView ? (
                                                <>

                                                    {this.state.campaignType === "1" && <SMSPreview
                                                        previewData={this.state.templatePreView}
                                                        smsContent={this.state.SMSmessage}
                                                    />}
                                                    {this.state.campaignType === "3" && (
                                                        this.state.previews.length > 0 ? (
                                                            <Carousel
                                                                autoPlay={false}
                                                                infiniteLoop={true}
                                                                showThumbs={false}
                                                                showArrows={true}
                                                                showStatus={false}
                                                                interval={5000}
                                                                renderArrowPrev={(onClickHandler, hasPrev, label) =>
                                                                    hasPrev && <CustomPrevArrow onClick={onClickHandler} />
                                                                }
                                                                renderArrowNext={(onClickHandler, hasNext, label) =>
                                                                    hasNext && <CustomNextArrow onClick={onClickHandler} />
                                                                }
                                                            >
                                                                {this.state.previews.map((preview, index) => (
                                                                    <SMSPreview
                                                                        previewData={preview}
                                                                        smsContent={this.state.SMSmessage}
                                                                    />
                                                                ))}
                                                            </Carousel>
                                                        ) : (
                                                            <SMSPreview
                                                                previewData={this.state.templatePreView}
                                                                smsContent={this.state.SMSmessage}
                                                            />
                                                        )
                                                    )}

                                                </>
                                            ) : (
                                                <div className="text-center">
                                                    <img className="img-fluid" src={no_data} />
                                                    <p className="text-right">
                                                        Please select {this.state.channel} Templte to
                                                        preview
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                );

            case 3:
                return (
                    <>
                        <div className="pb-4">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="campaign-preview sms-campaign-review">
                                        <div className="hr">Campaign Review</div>
                                        <hr className="mt-2" />

                                        <div className="campaign-details-grid">
                                            <div><strong>Campaign Name:</strong> {this.state.CampaignName}</div>
                                            <div><strong>Campaign Type:</strong> {this.state.campaignType === "1" ? "Normal" : "Custom (Dynamic)"} Campaign</div>
                                            <div><strong>Country Code:</strong> {this.state.country_code === 99999 ? "Multi-Country" : this.state.country_code}</div>
                                            <div className="number-source">
                                                <strong>Number Source:</strong>
                                                <div className="source-options">
                                                    {this.state.listId && <span className="chip">Contact List {this.state.listId}</span>}
                                                    {this.state.textnumbers && <span className="chip">Copy/Paste</span>}
                                                    {this.state.fileData && <span className="chip">CSV/XLSX</span>}
                                                </div>
                                            </div>
                                            <div><strong>Channel Selected:</strong> {this.state.channel}</div>
                                            <div><strong>Total Numbers:</strong> {this.state.numbersArray?.length + this.state.countData?.length + this.state.totalCount}</div>
                                            <div>
                                                <strong>Campaign Date:</strong>{" "}
                                                {this.state.schedule_datetime
                                                    ? this.state.schedule_datetime.replace("T", " ")
                                                    : ""}
                                            </div>
                                            <div>
                                                <strong>Campaign Template:</strong>{" "}
                                                {this.state.channel === "sms"
                                                    ? this.state.templatePreView.template_name
                                                    : this.state.templatePreView.tampleName}
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div className="form-group mt-3 ml-2">
                                <div className="form-check ">
                                    <p className="m-0 d-flex items-align-center">
                                        <input
                                            className="form-check-input mb-1"
                                            defaultValue={this.state.is_schedule}
                                            onChange={this.scheduleHandler}
                                            type="checkbox"
                                            value=""
                                            id="flexCheckDefault"
                                        />
                                        <strong> Campaign Schedule </strong>
                                    </p>
                                </div>
                                <small>
                                    {" "}
                                    Campaign scheduling is the process of specifying the start and
                                    end dates and times for a campaign.
                                </small>
                            </div>
                            {this.state.is_schedule === 1 && (
                                <>
                                    <p className="mt-3 d-block">
                                        <strong> Select Date and Time of Campaign </strong>
                                    </p>
                                    <div className="input-group w-25 mb-2 mr-sm-2">
                                        <div className="input-group-text">
                                            <FontAwesomeIcon icon={faAddressBook} />
                                        </div>
                                        <input
                                            type="datetime-local"
                                            className="form-control"
                                            onChange={(e) =>
                                                this.setState({ schedule_datetime: e.target.value })
                                            }
                                            placeholder="Example: campaign for digital marketing"
                                        />
                                    </div>
                                </>
                            )}
                        </div>
                    </>
                );

            default:
                return (
                    <div className="filter-option">
                        <div className="row justify-content-center">
                            <div className="col-md-4">
                                <p className="mt-3 d-block">Campaign Channel </p>
                                <div className="input-group drop-down-icons mb-2 mr-sm-2">
                                    <div className="input-group-text">
                                        <FontAwesomeIcon icon={faBroadcastTower} />
                                    </div>
                                    <select
                                        onChange={this.handleChannel}
                                        className="form-control"
                                        value={this.state.channel}
                                    >
                                        <option value={``}>Select Channel</option>
                                        <option value={`whatsapp`}>WhatsApp</option>
                                        <option value={`sms`}>SMS</option>
                                        <option value={`rcs`}>RCS</option>
                                    </select>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <p className="mt-3 d-block">Select Country </p>
                                <div className="d-flex align-items-center mb-2 mr-sm-2" style={{ flexWrap: "nowrap", width: "100%" }}>
                                    <div className="input-group-text d-flex align-items-center justify-content-center"
                                        style={{ minWidth: "40px", height: "43px", marginBottom: "10px", borderRadius: "0.375rem 0 0 0.375rem" }}>
                                        <FontAwesomeIcon icon={faFlag} />
                                    </div>

                                    <div style={{ flex: 1 }}>
                                        <Select
                                            options={[
                                                { value: "99999_Multi", label: "Multi" },
                                                ...this.state.countryList
                                                    .sort((a, b) => a.country_name.localeCompare(b.country_name))
                                                    .map((country) => ({
                                                        value: `${country.country_code}_${country.country_name}`,
                                                        label: `${country.country_name} (${country.country_code})`,
                                                    }))
                                            ]}
                                            value={{
                                                value: `${this.state.country_code}_${this.state.countryList.find(c => c.country_code === this.state.country_code)?.country_name || "Multi"}`,
                                                label: this.state.countryList.find(c => c.country_code === this.state.country_code)
                                                    ? `${this.state.countryList.find(c => c.country_code === this.state.country_code).country_name} (${this.state.country_code})`
                                                    : "Multi"
                                            }}
                                            onChange={(selectedOption) =>
                                                this.setState({ country_code: Number(selectedOption.value.split("_")[0]) })
                                            }
                                            classNamePrefix="react-select"
                                            styles={{
                                                control: (provided) => ({
                                                    ...provided,
                                                    borderRadius: "0 0.375rem 0.375rem 0",
                                                    minHeight: "43px"
                                                }),
                                            }}
                                            isSearchable
                                        />
                                    </div>

                                </div>
                            </div>

                            <div className="col-md-4">
                                <p className="mt-3 d-block">Select Campaign Type </p>
                                <div className="input-group drop-down-icons mb-2 mr-sm-2">
                                    <div className="input-group-text">
                                        <FontAwesomeIcon icon={faBroadcastTower} />
                                    </div>
                                    <select
                                        value={this.state.campaignType}
                                        onChange={(e) =>
                                            this.handleCampaignType(e)
                                        }
                                        className="form-control"
                                    >
                                        <option value="1"> Normal Campaign </option>
                                        <option value="3"> Custom (Dynamic) campaign</option>
                                    </select>
                                </div>
                            </div>

                            <div className="col-md-12">
                                <p className="mt-3 d-block">Enter Custom Campaign Name</p>
                                <div className="input-group mb-2 mr-sm-2">
                                    <div className="input-group-text">
                                        <FontAwesomeIcon icon={faAddressBook} />
                                    </div>
                                    <input
                                        type="text"
                                        defaultValue={this.state.CampaignName}
                                        className="form-control"
                                        onChange={this.onNameChange}
                                        // onChange={(e) =>
                                        //     this.setState({ CampaignName: this.state.CampaignName.length < 100 ? e.target.value : null })
                                        // }
                                        placeholder="Example: campaign for digital marketing"
                                    />
                                </div>
                                <small className="text-primary">
                                    Example : Campaign for remarketing
                                </small>
                            </div>
                        </div>
                    </div>
                );
        }
    };

    render() {
        // console.log("this.state", this.state);
        return (
            <div className="wrapper">
                <Helmet>
                    <style type="text/css">{`
         .whatsapp ul {
            display:none!important;
          }
        `}</style>
                </Helmet>

                {this.state.isLoading && (this.state.uploadProgress === 0) && <Spining />}
                {this.state.isLoading &&
                    (this.state.uploadProgress >= 100) &&
                    <div className={`${style.spinnerContainer} ${style.animatedText}`}>
                        Processing...
                    </div>
                }
                {this.state.isLoading &&
                    this.state.uploadProgress !== 0 &&
                    this.state.uploadProgress < 100 &&
                    <div className={style.spinnerContainer}>
                        <div className={style.spinnerWrapper}>
                            <div className={style.spinner}></div>
                            <div className={style.percentage}>
                                {this.state.uploadProgress}%
                            </div>
                            <p className={style.uploadText}>Uploading file</p>
                        </div>
                    </div>

                }
                <DashboardLeftMenu />
                <div className="main">
                    <DashboardHeader />
                    <main className="content">
                        <div className="container-fluid p-0">
                            <div className=" mb-2 mb-xl-3">
                                <div className="col-auto d-none d-sm-block">
                                    <h3>
                                        <strong>SMS Campaign </strong>
                                    </h3>
                                </div>
                            </div>
                            <div className="">
                                <div className="card">
                                    <div className="card-body">
                                        <div id="msform">
                                            <ul id="progressbar">
                                                {this.state.step === 0 ? (
                                                    <>
                                                        <li className="active">Campaign Details</li>
                                                        <li>Choose Audience </li>
                                                        <li>Campaign Template </li>
                                                        <li> Preview Campaign </li>
                                                    </>
                                                ) : this.state.step === 1 ? (
                                                    <>
                                                        <li className="active">Campaign Details</li>
                                                        <li className="active">Choose Audience</li>
                                                        <li>Campaign Template </li>
                                                        <li> Preview Campaign </li>
                                                    </>
                                                ) : this.state.step === 2 ? (
                                                    <>
                                                        <li className="active">Campaign Details</li>
                                                        <li className="active">Choose Audience </li>
                                                        <li className="active">Campaign Template </li>
                                                        <li> Preview Campaign </li>
                                                    </>
                                                ) : this.state.step === 3 ? (
                                                    <>
                                                        <li className="active">Campaign Details</li>
                                                        <li className="active">Choose Audience </li>
                                                        <li className="active">Campaign Template </li>
                                                        <li className="active"> Preview Campaign </li>
                                                    </>
                                                ) : null}
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                {this.state.isError ? (
                                    <div ref={this.errorRef}>
                                        <Alert type={this.state.messageType} clearError={this.clearError}>
                                            {this.state.errorMessage}
                                        </Alert>

                                    </div>
                                ) : null}

                                <div className="card">
                                    <div className="card-body campaign-box">
                                        {this.formRender()}

                                        <hr />

                                        <div className="row justify-content-center">
                                            <div className="col-md-4 mb-3">
                                                <button
                                                    disabled={this.state.step === 0}
                                                    onClick={() => this.prevStep()}
                                                    className={
                                                        this.state.step === 0
                                                            ? "btn btn-block btn-secondary"
                                                            : "btn btn-block btn-primary"
                                                    }
                                                >
                                                    <FontAwesomeIcon icon={faArrowCircleLeft} /> Previous
                                                </button>
                                            </div>
                                            <div className="col-md-4">
                                                {this.state.step === 3 ? (
                                                    <button
                                                        onClick={this.createCampaign}
                                                        className="btn btn-block btn-info"
                                                    >
                                                        <FontAwesomeIcon icon={faCheckCircle} /> Start
                                                        Campaign
                                                    </button>
                                                ) : (
                                                    <button
                                                        disabled={
                                                            this.state.isError ||
                                                            (this.state.campaignType === "3"
                                                                ? this.state.step === 1 &&
                                                                this.state.dynamicSampleData.length === 0 && !this.state.selectedOption
                                                                : this.state.step === 1 &&
                                                                (this.state.csvHeaders.length === 0 &&
                                                                    this.state.textnumbers === "" &&
                                                                    !this.state.selectedOption
                                                                )) || (this.state.step === 2 && this.state.templteId === "")
                                                        }
                                                        onClick={() => this.nextStep()}
                                                        className="btn btn-block btn-primary"
                                                    >
                                                        Next <FontAwesomeIcon icon={faArrowCircleRight} />
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.state.urlModalVisible && <UrlShortenerModal onClose={() => this.setState({ urlModalVisible: false })} onUrlSelect={this.handleUrlSelect} />}
                    </main>
                    <DashboardFooter />
                </div>
            </div>
        );
    }
}

class CustomPrevArrow extends Component {
    render() {
        return (
            <button
                onClick={this.props.onClick}
                style={{
                    position: "absolute",
                    top: "50%",
                    left: "-1%",
                    transform: "translateY(-50%)",
                    backgroundColor: "transparent",
                    border: "none",
                    color: "black",
                    fontSize: "30px",
                    zIndex: "1",
                }}
            >
                &#10094; {/* Unicode for left arrow */}
            </button>
        );
    }
}

class CustomNextArrow extends Component {
    render() {
        return (
            <button
                onClick={this.props.onClick}
                style={{
                    position: "absolute",
                    top: "50%",
                    right: "-1%",
                    transform: "translateY(-50%)",
                    backgroundColor: "transparent",
                    border: "none",
                    color: "black",
                    fontSize: "30px",
                    zIndex: "1",
                }}
            >
                &#10095; {/* Unicode for right arrow */}
            </button>
        );
    }
}

export default withRouter(SmsCampaignNew);